module.exports = __webpack_public_path__ + "static/media/IconTemplates_-87.2915d0ac.svg";